/**
 * Category image mapping: uses pre-generated slugImageMap.json
 * which maps every slug to a themed Unsplash image URL.
 *
 * Regenerate the map: node scripts/generateImageMap.cjs
 */

import slugImageMap from "@/data/slugImageMap.json";

const imageMap = slugImageMap as Record<string, string>;

const REALM_HERO_IMAGES: Record<string, string> = {
  "fantasy-names":          "https://images.unsplash.com/photo-1518709268805-4e9042af9f23?w=1200&q=80&auto=format&fit=crop",
  "real-names":             "https://images.unsplash.com/photo-1548013146-72479768bada?w=1200&q=80&auto=format&fit=crop",
  "places-locations":       "https://images.unsplash.com/photo-1533158307587-828f0a76ef46?w=1200&q=80&auto=format&fit=crop",
  "pop-culture":            "https://images.unsplash.com/photo-1577640905050-83665af216b9?w=1200&q=80&auto=format&fit=crop",
  "other-names":            "https://images.unsplash.com/photo-1610375461369-d613b564f4c4?w=1200&q=80&auto=format&fit=crop",
  "description-generators": "https://images.unsplash.com/photo-1519791883288-dc8bd696e667?w=1200&q=80&auto=format&fit=crop",
};

const DEFAULT_IMAGE = REALM_HERO_IMAGES["fantasy-names"];

/**
 * Returns the topic-matched image for any slug.
 * Uses the pre-built slugImageMap.json for instant O(1) lookup.
 */
export function imageForSlug(_categorySlug: string | null | undefined, slug: string): string {
  return imageMap[slug] || imageMap[_categorySlug || ""] || DEFAULT_IMAGE;
}

/**
 * The representative master image for a top-level category card.
 */
export function imageForCategory(categorySlug: string): string {
  return REALM_HERO_IMAGES[categorySlug] || DEFAULT_IMAGE;
}
